module.exports = __webpack_public_path__ + "static/img/newsaa.aee4c4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/newsaa.png
// module id = vrps
// module chunks = 45